import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl'; 
mapboxgl.accessToken = 'pk.eyJ1IjoiYm91emlybW9oYW1lZGFsaSIsImEiOiJja3p6enJiNTQwZmZ4M2twNmxhbXcwcjBnIn0.-rCrHrgt2jUb3bXffdqSqQ';
 
export default function App() {
const mapContainer = useRef(null);
const map = useRef(null);
const [lng, setLng] = useState(10.6384);
const [lat, setLat] = useState(35.8125);
const [zoom, setZoom] = useState(16.59);
 
useEffect(() => {
if (map.current) return; // initialize map only once
map.current = new mapboxgl.Map({
container: mapContainer.current,
style: 'mapbox://styles/mapbox/dark-v10',
center: [lng, lat],
zoom: zoom
});
});
 
useEffect(() => {
if (!map.current) return; // wait for map to initialize
map.current.on('move', () => {
setLng(map.current.getCenter().lng.toFixed(4));
setLat(map.current.getCenter().lat.toFixed(4));
setZoom(map.current.getZoom().toFixed(2));
});
});
 
return (
        <div>
            <div className="sidebarmap">
                Longitude: {lng} | Latitude: {lat} | Zoom: {zoom}
            </div>
            <div ref={mapContainer} className="map-container-box" />
        </div>
        );
}